import { useState } from 'react';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { Button, Box, Drawer, IconButton, styled } from '@mui/material';
import Iconify from 'src/components/iconify';
import Scrollbar from 'src/components/scrollbar';
import logo from './images/logo.png';

const headerLinks = [
  { title: 'Why VPSi?', path: '#solutions' },
  { title: 'Sensor', path: '#sensor' },
  // { title: 'Testimonials', path: '#testimonials' },
  { title: 'About', path: '#about' },
];

const StyledLogo = styled('img')(({ theme }) => ({
  width: '280px',
  height: '100%',

  [`@media screen and (max-width: ${theme.breakpoints.values.md}px)`]: {
    width: '30vw',
  },
}));

export default function Header() {
  const [openNav, setOpenNav] = useState(false);

  return (
    <>
      <Box
        sx={{
          color: 'text.primary',
          bgcolor: 'action.selected',
          display: 'flex',
          justifyContent: 'center',
          padding: { xs: '8px 12px', md: '25px 50px' },
        }}
      >
        <Box sx={{ maxWidth: '1200px', display: 'flex', justifyContent: 'flex-end', gap: '8px', width: '100%' }}>
          <Button
            color="inherit"
            size="large"
            startIcon={<ChatBubbleOutlineIcon color="error" />}
            sx={{
              fontWeight: '800',
              fontSize: { xs: '12px', md: '20px' },
              borderRadius: '100px',
              padding: { xs: '6px 12px', md: '16px 25px' },
              fontFamily: 'ZalandoSans',
            }}
            href="mailto:james.mcglothlin@videoplussensors.com"
          >
            Contact Us
          </Button>
          <Button
            href="/login"
            color="error"
            variant="contained"
            size="large"
            sx={{
              fontWeight: '800',
              fontSize: { xs: '12px', md: '20px' },
              borderRadius: '100px',
              padding: { xs: '6px 12px', md: '16px 25px' },
              fontFamily: 'ZalandoSans',
            }}
          >
            My VPSi Login
          </Button>
        </Box>
      </Box>
      <Box
        sx={{
          color: 'text.primary',
          display: 'flex',
          justifyContent: 'center',
          padding: { xs: '12px 16px', md: '25px 50px' },
        }}
      >
        <Box sx={{ maxWidth: '1200px', display: 'flex', justifyContent: 'space-between', gap: '8px', width: '100%' }}>
          <StyledLogo src={logo} alt="VPSi Logo" />
          <Box sx={{ marginLeft: '20px', gap: 1, alignItems: 'center', display: { xs: 'none', md: 'flex' } }}>
            {headerLinks.map((link, i) => (
              <Button
                href={link.path}
                sx={{
                  color: 'text.primary',
                  fontSize: '25px',
                  fontWeight: '700',
                  height: '50%',
                  fontFamily: 'ZalandoSans',
                }}
                key={`header-link-${i}`}
              >
                {link.title}
              </Button>
            ))}
          </Box>
          <IconButton
            onClick={() => setOpenNav(true)}
            sx={{
              mr: 1,
              color: 'text.primary',
              display: { md: 'none' },
            }}
          >
            <Iconify icon="eva:menu-2-fill" width="35px" />
          </IconButton>
          <Drawer
            open={openNav}
            onClose={() => setOpenNav(false)}
            ModalProps={{
              keepMounted: true,
            }}
            PaperProps={{
              sx: { width: 280 },
            }}
          >
            <Scrollbar
              sx={{
                height: 1,
                '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
              }}
            >
              <img src={logo} alt="VPSi Logo" style={{ width: '80%', margin: '40px auto' }} />
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, px: 2 }}>
                {headerLinks.map((link, i) => (
                  <Button
                    href={link.path}
                    sx={{
                      color: 'text.primary',
                      fontSize: '25px',
                      fontWeight: '700',
                      height: '50%',
                      fontFamily: 'ZalandoSans',
                    }}
                    key={`header-link-${i}`}
                    onClick={() => setOpenNav(false)}
                  >
                    {link.title}
                  </Button>
                ))}
              </Box>
              <Box sx={{ flexGrow: 1 }} />
            </Scrollbar>
          </Drawer>
        </Box>
      </Box>
    </>
  );
}
